import { createContext, useContext, useMemo, useSyncExternalStore } from 'react';
import type { FormController } from '../state/controller';
import type { FormState } from '../state/types';
import type { RuntimeConfig } from '../config';
import type { StripeBridge } from '../payments/stripe';
import { moneyFormatter, type MoneyFormatter } from './format';

export interface FormEnvironment {
  controller: FormController;
  config: RuntimeConfig;
  stripe: StripeBridge;
  now: () => Date;
}

export const FormContext = createContext<FormEnvironment | null>(null);

export function useEnv(): FormEnvironment {
  const env = useContext(FormContext);
  if (!env) throw new Error('FormContext missing');
  return env;
}

export function useFormState(): FormState {
  const { controller } = useEnv();
  return useSyncExternalStore(controller.subscribe, controller.getState, controller.getState);
}

/** Currency formatter for the tenant (stable per settings object). */
export function useMoney(): MoneyFormatter {
  const settings = useFormState().bootstrap?.settings ?? null;
  return useMemo(() => moneyFormatter(settings), [settings]);
}
